import styled from 'styled-components'

const OffersAside = styled.div`
  overflow-y: auto;
  max-height: ${props => props.height || 'auto'};
`
export default OffersAside
